import { Typography } from "@mui/material";

export const support = {

  contact: "+91 8105057585",
  email: "support@mindsclik.com",
  address: <Typography
    variant="subtitle1"
    color="text.secondary"
    textTransform="capitalize"
  >
    MindsClik Digital Solutions Private Limited
    3rd Floor, Plot # 72 & 73, Akshay Tech Park, EPIP Zone
    Whitefield Rd, Vijayanagar, KIADB Export Promotion
    Industrial Area, Whitefield, Bengaluru, Karnataka 560066
  </Typography>



}